// API_ALLMODULE
import { URL, axios } from '@/util/request.js';
export function allModule() {
    return axios.post(URL.API_ALLMODULE)
}


export function moduleDetail(id){
    return axios.post(URL.API_MODULELIST+"/"+id);
}